export default __webpack_public_path__ + "static/media/Icon awesome-question-circle.06a2baf4.svg";